import { render } from "react-dom";
import { GalleryItem, GalleryItemProps } from "./GalleryItem";
import { ReactSortable } from "react-sortablejs";

export interface OrderGalleryListProps<T extends GalleryItemProps> {
    items: T[];
    setItems: (newItems: T[]) => void;
}
export const OrderGalleryList = <T extends GalleryItemProps,>({ items, setItems }: OrderGalleryListProps<T>) => {
    return (
        <div>
            <ReactSortable list={items} setList={setItems} handle=".upload-handle" >
                {items.map((item) => <GalleryItem key={item.id} {...item}  />)}
            </ReactSortable >
        </div>
    )
}